import { render, staticRenderFns } from "./MovimientosTable.vue?vue&type=template&id=e93d77b0&lang=pug&"
import script from "./MovimientosTable.vue?vue&type=script&lang=js&"
export * from "./MovimientosTable.vue?vue&type=script&lang=js&"
import style0 from "./MovimientosTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports